import { type FlipIntent } from 'wdc-cube'
import {
    TcmPresenterForFilterCatalogForm,
    TcmPresenterForFilterCatalogShare,
    type FilterCatalogDialogContext
} from '../the-consumer-market/tcm_presenter_filter_pane/tcm_filter_catalog_presenter'
import { MercadoVetKeys, MvFilterCatalogFormKeys, MvFilterCatalogShareKeys } from './mv_keys'

function catalogOf(keys: MercadoVetKeys) {
    const mv = keys.mvPresenter
    return mv.scope.tab === 'web' ? mv.webPage.filterPane.catalog : mv.cnpjPage.filterPane.catalog
}

export class MvFilterCatalogFormPresenter extends TcmPresenterForFilterCatalogForm {
    protected override resolveContext(intent: FlipIntent): FilterCatalogDialogContext {
        const keys = new MvFilterCatalogFormKeys(this.app, intent)
        return {
            mode: keys.mode,
            sourceId: keys.sourceId,
            catalog: catalogOf(keys),
            dialogSlot: (scope) => keys.dialogSlot(scope)
        }
    }

    protected override async flipBack() {
        await new MercadoVetKeys(this.app).flip()
    }
}

export class MvFilterCatalogSharePresenter extends TcmPresenterForFilterCatalogShare {
    protected override resolveContext(intent: FlipIntent): FilterCatalogDialogContext {
        const keys = new MvFilterCatalogShareKeys(this.app, intent)
        return {
            mode: 'create',
            sourceId: keys.sourceId,
            catalog: catalogOf(keys),
            dialogSlot: (scope) => keys.dialogSlot(scope)
        }
    }

    protected override async flipBack() {
        await new MercadoVetKeys(this.app).flip()
    }
}
